import { makeAutoObservable, runInAction } from "mobx";

import { countryAjaxController } from "../Ajax/CountryAjaxController";
import { Country } from "../DTOs/Address/Country";

class CountryController {
  countries: Country[] = [];
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
    this.fetchCountries();
  }

  async fetchCountries() {
    if (this.countries.length > 0 || this.isLoading) return this.countries;
    this.isLoading = true;
    try {
      const res = await countryAjaxController.getCountries();
      runInAction(() => {
        this.countries = res ?? [];
      });
    } finally {
      runInAction(() => (this.isLoading = false));
    }
    return this.countries;
  }

  findByIsoOrName(val?: string) {
    if (!val) return undefined;
    const upper = val.trim().toUpperCase();
    return this.countries.find(c => c.name.toUpperCase() === upper);
  }
}

export const countryController = new CountryController();
